import queries from '@apis/queries';
import Button from '@components/Button';
import Column from '@components/Column';
import PrepaidContext from '@components/prepaid/PrepaidProvider/PrepaidContext';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';

import usePrepaidCharge from './hooks/usePrepaidCharge';

interface Props {
    id: string;
}

function PrepaidCardChargeFooter({ id }:Props) {
  const { amount } = useContext(PrepaidContext);
  const { data } = useQuery(queries.userPrepaidCard.detail(id));
  const { handleCharge } = usePrepaidCharge(id);
  return (
        <Column fullWidth spacing={16}>
            <Column fullWidth spacing={8}>
                <Row fullWidth justify='space-between'>
                    <Text color={colors.gray6}
                          size='lg'
                          fontWeight='bold'>현재 잔액</Text>
                    <Text size='lg'>{data?.balance.toLocaleString()}원 </Text>
                </Row>
                <Row fullWidth justify='space-between'>
                    <Text color={colors.gray6}
                          size='lg'
                          fontWeight='bold'>충전 금액</Text>
                    <Text size='lg'>+{(amount * 10000).toLocaleString()}원  </Text>
                </Row>
                <Row fullWidth justify='space-between'>
                    <Text size='xl'
                          fontWeight='bold'>충전 후 금액</Text>
                    <Text size='3xl'
                          color={colors.red}
                          fontWeight='bold'>
                        {(amount * 10000 + (data?.balance || 0)).toLocaleString()}원
                    </Text>
                </Row>
            </Column>
            <Button fullWidth onClick={handleCharge}>
                결제하기
            </Button>
        </Column>
  );
}

export default PrepaidCardChargeFooter;
